{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-120000",
  "definition": "[120000] Disclosure - Directors report",
  "sheetId": "DirectorsReport",
  "label": "Directors Report",
  "controls": [
    {
      "qname": "ssmt:DisclosureOfDirectorsReportExplanatory",
      "label": "Disclosure of Director's Report",
      "type": "TextBlock",
      "ui": { "control": "richtext", "rows": 10 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:NumberOfDirectorsSigningDirectorsReport",
      "label": "Number of directors signing Director's report",
      "type": "TypeOfNumberOfDirectorsSigningDirectorsReport",
      "ui": { "control": "select", "enumSource": "type:TypeOfNumberOfDirectorsSigningDirectorsReport" },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] },
      "uiDefault": "1"
    },
    {
      "qname": "ssmt:NameOfFirstDirectorWhoSignedDirectorsReport",
      "label": "Name of first director who signed Director's report",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 1 },
      "required": true,
      "validators": [{ "name": "required" }, { "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfIdentificationOfFirstDirectorWhoSignedDirectorsReport",
      "label": "Type of identification of first director who signed director's report",
      "type": "TypeOfIdentification",
      "ui": { "control": "select", "enumSource": "type:TypeOfIdentification", "directorNumber": 1 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:IdentificationNumberOfFirstDirectorWhoSignedDirectorsReport",
      "label": "Identification number of the first director who signed director's report",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 1, "maxLength": 255 },
      "required": true,
      "validators": [
        { "name": "required" },
        { "name": "maxLength", "value": 255 },
        {
          "name": "pattern",
          "pattern": "^[0-9]{12}$",
          "message": "Please input a 12 digit Identification number.",
          "conditionalOn": {
            "qname": "ssmt:TypeOfIdentificationOfFirstDirectorWhoSignedDirectorsReport",
            "values": ["MyKad", "MyPR", "MyKAS"]
          }
        }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Please input a 12 digit Identification number.",
        "maxlength": "Identification number must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:NameOfSecondDirectorWhoSignedDirectorsReport",
      "label": "Name of second director who signed the director's report",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 2, "maxLength": 255 },
      "required": true,
      "validators": [{ "name": "required" }, { "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfIdentificationOfSecondDirectorWhoSignedDirectorsReport",
      "label": "Type of identification of second director who signed Director's report",
      "type": "TypeOfIdentification",
      "ui": { "control": "select", "enumSource": "type:TypeOfIdentification", "directorNumber": 2 },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:IdentificationNumberOfSecondDirectorWhoSignedDirectorsReport",
      "label": "Identification number of the second director who signed director's report",
      "type": "String",
      "ui": { "control": "text", "directorNumber": 2, "maxLength": 255 },
      "required": true,
      "validators": [
        { "name": "required" },
        { "name": "maxLength", "value": 255 },
        {
          "name": "pattern",
          "pattern": "^[0-9]{12}$",
          "message": "Please input a 12 digit Identification number.",
          "conditionalOn": {
            "qname": "ssmt:TypeOfIdentificationOfSecondDirectorWhoSignedDirectorsReport",
            "values": ["MyKad", "MyPR", "MyKAS"]
          }
        }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Please input a 12 digit Identification number.",
        "maxlength": "Identification number must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:NameOfThirdDirectorWhoSignedDirectorsReport",
      "label": "Name of third director who signed the director's report",
      "type": "String",
      "required": true,
      "ui": { "control": "text", "directorNumber": 3, "maxLength": 255 },
      "validators": [{ "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfIdentificationOfThirdDirectorWhoSignedDirectorsReport",
      "label": "Type of identification of third director who signed Director's report",
      "type": "TypeOfIdentification",
      "required": true,
      "ui": { "control": "select", "enumSource": "type:TypeOfIdentification", "directorNumber": 3 },
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:IdentificationNumberOfThirdDirectorWhoSignedDirectorsReport",
      "label": "Identification number of the third director who signed director's report",
      "type": "String",
      "required": true,
      "ui": { "control": "text", "directorNumber": 3, "maxLength": 255 },
      "validators": [
        { "name": "maxLength", "value": 255 },
        {
          "name": "pattern",
          "pattern": "^[0-9]{12}$",
          "message": "Please input a 12 digit Identification number.",
          "conditionalOn": {
            "qname": "ssmt:TypeOfIdentificationOfThirdDirectorWhoSignedDirectorsReport",
            "values": ["MyKad", "MyPR", "MyKAS"]
          }
        }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Please input a 12 digit Identification number.",
        "maxlength": "Identification number must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:NameOfFourthDirectorWhoSignedDirectorsReport",
      "label": "Name of fourth director who signed the director's report",
      "type": "String",
      "required": true,
      "ui": { "control": "text", "directorNumber": 4, "maxLength": 255 },
      "validators": [{ "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfIdentificationOfFourthDirectorWhoSignedDirectorsReport",
      "label": "Type of identification of fourth director who signed Director's report",
      "type": "TypeOfIdentification",
      "required": true,
      "ui": { "control": "select", "enumSource": "type:TypeOfIdentification", "directorNumber": 4 },
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:IdentificationNumberOfFourthDirectorWhoSignedDirectorsReport",
      "label": "Identification number of the fourth director who signed director's report",
      "type": "String",
      "required": true,
      "ui": { "control": "text", "directorNumber": 4, "maxLength": 255 },
      "validators": [
        { "name": "maxLength", "value": 255 },
        {
          "name": "pattern",
          "pattern": "^[0-9]{12}$",
          "message": "Please input a 12 digit Identification number.",
          "conditionalOn": {
            "qname": "ssmt:TypeOfIdentificationOfFourthDirectorWhoSignedDirectorsReport",
            "values": ["MyKad", "MyPR", "MyKAS"]
          }
        }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Please input a 12 digit Identification number.",
        "maxlength": "Identification number must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:NameOfFifthDirectorWhoSignedDirectorsReport",
      "label": "Name of fifth director who signed the director's report",
      "type": "String",
      "required": true,
      "ui": { "control": "text", "directorNumber": 5, "maxLength": 255 },
      "validators": [{ "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfIdentificationOfFifthDirectorWhoSignedDirectorsReport",
      "label": "Type of identification of fifth director who signed Director's report",
      "type": "TypeOfIdentification",
      "required": true,
      "ui": { "control": "select", "enumSource": "type:TypeOfIdentification", "directorNumber": 5 },
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:IdentificationNumberOfFifthDirectorWhoSignedDirectorsReport",
      "label": "Identification number of the fifth director who signed director's report",
      "type": "String",
      "required": true,
      "ui": { "control": "text", "directorNumber": 5, "maxLength": 255 },
      "validators": [
        { "name": "maxLength", "value": 255 },
        {
          "name": "pattern",
          "pattern": "^[0-9]{12}$",
          "message": "Please input a 12 digit Identification number.",
          "conditionalOn": {
            "qname": "ssmt:TypeOfIdentificationOfFifthDirectorWhoSignedDirectorsReport",
            "values": ["MyKad", "MyPR", "MyKAS"]
          }
        }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Please input a 12 digit Identification number.",
        "maxlength": "Identification number must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOfStatusOfDividend",
      "label": "Disclosure of status of dividend (final dividend)",
      "type": "TypeOfStatusOfDividend",
      "ui": { "control": "select", "enumSource": "type:TypeOfStatusOfDividend" },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOfContingentOrOtherLiabilityBeingEnforceableWithinTwelveMonthsAfterEndOfFinancialYear",
      "label": "Disclosure of contingent or other liability being enforceable within twelve months after the end of financial year",
      "type": "YesNoItemType",
      "ui": { "control": "select", "enumSource": "type:YesNoItemType" },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOfOccurenceOfAnySubstantialMaterialOrUnusualInNatureItemsTransactionsOrEvents",
      "label": "Disclosure of occurrence of any substantial, material or unusual in nature items, transactions or events",
      "type": "YesNoItemType",
      "ui": { "control": "select", "enumSource": "type:YesNoItemType" },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOfDirectorsReceivedOrBecomeEntitledToReceiveOtherBenefitsByReasonOfContractMadeByCompanyOrRelatedCorporation",
      "label": "Disclosure of directors received or become entitled to receive other benefits by reason of contract made by company or related corporation",
      "type": "YesNoItemType",
      "ui": { "control": "select", "enumSource": "type:YesNoItemType" },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DateOfSigningDirectorsReport",
      "label": "Date of signing director's report",
      "type": "Date",
      "ui": { "control": "date" },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "warnings": [
        {
          "id": "directors-report-date-before-year-end",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "dateComparison",
            "message": "\"Date of signing director's report\" must be greater than \"Company's current financial year end date\"",
            "comparisonOperator": "lte",
            "compareWith": {
              "sheet": "filingPrerequisites",
              "field": "ssmt-dei:CompanyCurrentFinancialYearEndDate"
            }
          }
        },
        {
          "id": "directors-report-date-before-auditors-report-date",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "dateComparison",
            "message": "When \"Disclosure of financial statements audit status\" is \"Audited\", then \"Date of signing director's report\" must be greater than or equal to \"Date of signing auditor's report\".",
            "comparisonOperator": "lt",
            "compareWith": {
              "sheet": "auditorsReport",
              "field": "ssmt:DateOfSigningAuditorsReport"
            },
            "conditionalOn": {
              "sheet": "filingPrerequisites",
              "field": "ssmt-dei:DisclosureOfFinancialStatementsAuditStatus",
              "equals": "Audited"
            }
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "I_CUR", "allowedAxes": [] }
    }
  ]
}
